import Tour from '@core/components/Tour';
import { useReduxLoading } from '@core/hooks';
import { useApiUtils } from '@core/util/apiUtils';
import { vendasTour } from '@core/util/mockTourUtils';
import FusePageCarded from '@fuse/core/FusePageCarded';
import { cancelarAlert, excluirAlert, simpleAlert } from 'app/services/alerts';
import empresaApi from 'app/services/api/empresaApi';
import { pendenciasCobrancaApi } from 'app/services/api/pendenciasCobrancaApi';
import { relatorioApi } from 'app/services/api/relatorioApi';
import { usuarioApi } from 'app/services/api/usuarioApi';
import { vendaApi } from 'app/services/api/vendaApi';
import * as Actions from 'app/store/actions';
import { GlobalContext } from 'app/store/globalcontext';
import { eventReactGA, initializeReactGA } from 'app/utils/analyticsUtil';
import { visualizarRelatorioV2 } from 'app/utils/enviromentUtil';
import { getEmpresaContexto } from 'app/utils/geralUtil';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import {
  CadastroVendaModal,
  OrcamentoMail,
  VendaPendenciasModal,
  VendaTable,
  VisualizarVendaModal,
} from './components';
import { VendaModais } from './components/modal/VendaModais';
import { steps } from './components/steps/VendaSteps';
import VendaBuscaAvancadaModal from './components/VendaBuscaAvancada/VendaBuscaAvancadaModal';
import VendaSearchHeader from './components/VendaSearchHeader/VendaSearchHeader';
import { VendaContext, VendaProvider } from './VendaContext';

const VENDA = 'Venda';

const Venda = () => {
  const [, setSelecao] = useContext(VendaContext).selecao;
  const [, setTipoSelecao] = useContext(VendaContext).tipoSelecao;
  const [, setVendas] = useContext(VendaContext).vendas;
  const [, setVendaAtual] = useContext(VendaContext).vendaAtual;
  const [, setTotalElements] = useContext(VendaContext).totalElements;
  const [, setModal] = useContext(VendaContext).modal;
  const [loading, setLoading] = useContext(VendaContext).loading;
  const [, setIdVendaAtual] = useContext(VendaContext).idVendaAtual;
  const [, setTemplateMailOrcamento] = useContext(VendaContext).templateMailOrcamento;
  const [, setVisualizarPendencias] = useContext(VendaContext).visualizarPendencias;
  const [, setPendencias] = useContext(VendaContext).pendencias;
  const [, setEmail] = useContext(VendaContext).email;
  const [filtroAvancado] = useContext(VendaContext).filtroAvancado;
  const [, setEmpresa] = useContext(GlobalContext).empresa;
  const [, setPage] = useContext(VendaContext).page;
  const [, setSize] = useContext(VendaContext).size;
  const [funcionalidadesTour, setFuncionalidadesTour] = useContext(GlobalContext).funcionalidadesTour;

  const [run, setRun] = useState(false);
  const [onTour, setOnTour] = useState(false);
  const [modalSelecionarContratos, setModalSelecionarContratos] = useState(false);

  const history = useHistory();

  const dispatch = useDispatch();
  const apiUtils = useApiUtils(dispatch, Actions);

  useReduxLoading(loading);

  const showSuccess = (message) => {
    dispatch(Actions.showMessage({ message, variant: 'success' }));
  };

  useEffect(() => {
    initializeReactGA(history?.location?.pathname);
    if (!funcionalidadesTour) {
      setFuncionalidadesTour([]);
    }
    buscarTour();
    async function buscarEmpresa() {
      const response = await empresaApi.buscar(getEmpresaContexto());
      setEmpresa(response.data);
    }

    buscarEmpresa();
    // Efeito de montagem: roda uma única vez. Incluir as dependências reexecutaria a carga
    // inicial a cada render (loop de chamadas à API).
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const carregarDadosTour = () => {
    setSelecao([]);
    setPage(1);
    setSize(vendasTour.length);
    setTotalElements(3);
    setVendas(vendasTour);
  };

  const buscarTour = async () => {
    const funcionalidadeJaExistente = funcionalidadesTour?.some((f) => f === 'VENDAS');
    if (!funcionalidadeJaExistente) {
      setRun(true);
      setOnTour(true);
      carregarDadosTour();
    } else {
      fetchVendas();
    }
  };

  const resetSelecao = () => {
    setSelecao([]);
    setTipoSelecao('NENHUM');
  };

  const initialPage = {
    page: 0,
    q: '',
    size: 15,
    sort: 'data,DESC',
  };

  const handleSelectionChange = (selecao) => {
    setSelecao(selecao);
  };

  const fetchVenda = async (vendaId, historico) => {
    let response;
    setLoading(true);
    try {
      response = await vendaApi().buscar(vendaId);
      const venda = response?.data;

      if (historico) {
        venda.historico = historico;
      }

      if (venda?.pagamento?.parcelamento?.parcelas) {
        definirNumParcelas(venda?.pagamento?.parcelamento?.parcelas);
      }

      setVendaAtual(venda);
    } catch (err) {
      apiUtils.handleApiError(err);
    }
    setLoading(false);
    return response?.data;
  };

  const definirNumParcelas = (parcelas) => {
    parcelas.forEach((item, index) => {
      item.numParcela = index + 1;
    });
  };

  const fetchVendas = async (search = initialPage) => {
    setLoading(true);
    try {
      if (!search?.filtroAvancado) {
        search.filtroAvancado = filtroAvancado;
      }

      const response = await vendaApi().buscarTodos(search);
      setSelecao([]);
      setPage(response.data.number);
      setSize(response.data.size);
      setTotalElements(response.data.totalElements);
      setVendas(response.data.content);
    } catch (err) {
      apiUtils.handleApiError(err);
    }

    setLoading(false);
  };

  const handleDelete = (filtro) => {
    excluirAlert({
      confirmar: async () => {
        try {
          setLoading(true);
          eventReactGA(VENDA, 'Excluir venda');
          const vendas = { ...filtro, ids: filtro.ids.map((p) => p.id) };
          await vendaApi().excluir(vendas);
          setLoading(false);
          showSuccess(filtro?.ids.length === 1 ? 'Venda excluída com sucesso' : 'Vendas excluídas com sucesso');
          resetSelecao();
          fetchVendas();
        } catch (err) {
          apiUtils.handleApiError(err);
        }
        setLoading(false);
      },
    });
  };

  const aprovarVenda = async (venda) => {
    setLoading(true);
    const pendencias = await verificarPendencias(venda);

    // Se houverem pendências para gerar cobrança, exibe o modal, senão aprova a venda.
    if (pendencias?.length > 0) {
      setPendencias(pendencias);

      setVisualizarPendencias(true);

      setLoading(false);
    } else {
      try {
        eventReactGA(VENDA, 'Aprovar venda');
        await vendaApi().aprovarVenda(venda.id);
        showSuccess('Venda aprovada com sucesso');
        resetSelecao();
        fetchVendas();
      } catch (err) {
        apiUtils.handleApiError(err);
      } finally {
        setLoading(false);
      }
    }
  };

  const emitirPedidoVenda = async (venda, tipoVenda = 'venda') => {
    try {
      setLoading(true);
      eventReactGA(VENDA, 'Emitir pedido de venda');
      const response = await relatorioApi().salvarFiltroPedidoVenda(venda.id);
      visualizarRelatorioV2(response.data);
      // visualizarRelatorio(venda.id, 'venda/pedido', `titulo=${tipoVenda}_${venda.identificador}`);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      apiUtils.handleApiError(error);
    }
  };

  const handleOpenModalEnviarOrcamento = async (idVenda) => {
    try {
      setLoading(true);
      const response = await vendaApi().getTemplateMailOrcamento(idVenda);
      setTemplateMailOrcamento(response.data?.template);

      setIdVendaAtual(idVenda);
      setEmail(response.data?.email);
      setLoading(false);
      setModal(VendaModais.enviarOrcamento);
    } catch (e) {
      console.error(e);
    }
  };

  const verificarPendencias = async (venda) => {
    try {
      const formaRecebimento = venda?.pagamento?.formaRecebimento || venda?.formaRecebimento;

      const resp = await pendenciasCobrancaApi().buscar(formaRecebimento, venda?.clienteId);

      return resp.data;
    } catch (error) {
      apiUtils.handleApiError(error);
    }
  };

  const handleSubmit = async (_venda, pageable, enviarOrcamento) => {
    setLoading(true);

    // RNE-590
    const pendencias = _venda?.situacao === 'VENDA_APROVADA' && (await verificarPendencias(_venda));

    // Se houverem pendências para gerar cobrança, exibe o modal, senão realiza o cadastro da venda.
    if (pendencias?.length > 0) {
      setPendencias(pendencias);

      setVisualizarPendencias(true);

      setLoading(false);
    } else {
      let res;
      let message;

      try {
        if (_venda?.id) {
          eventReactGA(VENDA, 'Atualizar venda');
          res = await vendaApi().atualizar(_venda);
          message = 'Venda editada com sucesso';
        } else {
          eventReactGA(VENDA, 'Cadastrar venda');
          res = await vendaApi().criar(_venda);
          message = 'Venda salva com sucesso';
        }

        showSuccess(message);
        resetSelecao();
        setModalSelecionarContratos(false);
        fetchVendas(pageable);
      } catch (err) {
        if (err?.response?.data?.errorKey === 'venda.vendaDuplicada') {
          cancelarAlert({
            opcoes: {
              title:
                'Identificamos que já existe uma venda realizada com o mesmo cliente, data de vencimento e valor total. Deseja continuar?',
              text: '',
            },
            confirmar: async () => {
              setLoading(true);
              try {
                if (_venda?.id) {
                  res = await vendaApi().atualizar(_venda);
                  message = 'Venda editada com sucesso';
                } else {
                  res = await vendaApi().criar(_venda, true);
                  message = 'Venda salva com sucesso';
                }
                setModal('');
                setModalSelecionarContratos(false);
                showSuccess(message);
                resetSelecao();
                fetchVendas();
              } catch (error) {
                apiUtils.handleApiError(error);
              }
              setLoading(false);
              if (enviarOrcamento) {
                handleOpenModalEnviarOrcamento(res.data.id);
              }
            },
          });
        } else if (err?.response?.data?.errorKey === 'erro.atualizar.venda.unificada') {
          simpleAlert({
            opcoes: {
              title: err.response?.data?.message,
            },
          });
        } else {
          apiUtils.handleApiError(err);
        }
      }

      setLoading(false);

      if (enviarOrcamento) {
        handleOpenModalEnviarOrcamento(res.data.id);
      }

      return res;
    }
  };

  const atualizarTour = async () => {
    try {
      setLoading(true);
      funcionalidadesTour.push('VENDAS');
      await usuarioApi.updateTour(funcionalidadesTour);
      setRun(false);
      setOnTour(false);
      setFuncionalidadesTour(funcionalidadesTour);
      fetchVendas();
    } catch (err) {
      apiUtils.handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Tour
        steps={steps}
        run={run}
        setRun={setRun}
        disableScrolling={true}
        onFinish={() => {
          atualizarTour();
        }}
      />
      <FusePageCarded
        innerScroll
        header={<VendaSearchHeader />}
        content={
          <>
            <VendaTable
              onSelection={handleSelectionChange}
              fetchVenda={fetchVenda}
              fetchVendas={fetchVendas}
              onDelete={handleDelete}
              aprovarVenda={aprovarVenda}
              emitirPedidoVenda={emitirPedidoVenda}
              handleOpenModalEnviarOrcamento={handleOpenModalEnviarOrcamento}
              onTour={onTour}
            />

            <CadastroVendaModal
              onSubmit={handleSubmit}
              modalSelecionarContratos={modalSelecionarContratos}
              setModalSelecionarContratos={setModalSelecionarContratos}
            />
            <VisualizarVendaModal emitirPedidoVenda={emitirPedidoVenda} />
            <OrcamentoMail />
            <VendaPendenciasModal />
            <VendaBuscaAvancadaModal fetchVendas={fetchVendas} initialPage={initialPage} />
          </>
        }
      />
    </>
  );
};

const VendaContainer = () => (
  <VendaProvider>
    <Venda />
  </VendaProvider>
);

export default VendaContainer;
